<template>
  <MainLayout>
    <div class="container mw-960" slot="layout-body">
      <div class="error-container text-center">
        <img src="/static/images/signin-lcic-inactive.svg">
        <div class="typography--content-body"
             v-html="$t('errors.not_found_msg')">
        </div>
      </div>
    </div>

    <AppFooter slot="footer"></AppFooter>
  </MainLayout>
</template>

<script>
  export default {
    name: 'not-found',
  };
</script>



// WEBPACK FOOTER //
// src/app/errors/views/NotFound.vue